import Ogolne from './Ogolne';
import Public from './Public';

const pageComponents = {
  Ogolne,
  Public
};

export default pageComponents;
